
import React from "react";
import { useLocation } from "react-router-dom";
import { navItems } from "./navTypes";

const MobileNavSelector: React.FC = () => {
  const location = useLocation();

  return (
    <div className="md:hidden mb-4">
      <select 
        className="w-full bg-background border rounded p-2"
        value={location.pathname}
        onChange={(e) => window.location.href = e.target.value}
      >
        {navItems.flatMap((item) => [
          <option key={item.href} value={item.href}>
            {item.title}
          </option>,
          ...(item.subItems?.map(subItem => (
            <option key={subItem.href} value={subItem.href}>
              └─ {subItem.title}
            </option>
          )) || [])
        ])}
      </select>
    </div>
  );
};

export default MobileNavSelector;
